import styled from 'styled-components'

export const View = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .separator {
    border-left: 1px solid black;
    margin: 0 2rem;
  }
`
